import { Component, OnInit, TemplateRef } from '@angular/core';
import { BlogService } from '../blog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '@root/shared/services/api.service';
import { Urls } from '@root/utils/urls';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '@root/shared/services/common-data.service';
import { DownloadFileService } from '@root/shared/services/download-file.service';
import { Something_went_wrong } from '@root/app.constant';


@Component({
  selector: 'app-view-all-blogs',
  templateUrl: './view-all-blogs.component.html',
  styleUrls: ['./view-all-blogs.component.scss']
})
export class ViewAllBlogsComponent implements OnInit {
  videos: any[];
  infographics: any[];
  reads: any[];
  videosList: any[];
  displayCount = 6;
  activeTab: any;
  infographicsList: any = []
  readList: any = []

  constructor(private blogService:BlogService, private route:ActivatedRoute, private modalService:NgbModal, private apiService:ApiService, private toastr:ToastrService, private router:Router, private commonDataService:CommonDataService,private downloadFileService:DownloadFileService,) { }

  ngOnInit() {
    //  this.activeTab = this.blogService.getActiveTab();
    this.activeTab = this.route.snapshot.paramMap.get('blogType') || '';
    this.getData()
  }

  getData(){  
    if (this.activeTab === 'watch') {
      this.commonDataService.loaderStatus.next(true);
      this.apiService.getData(Urls.getIapPageVideos).subscribe(
        (response) => {
          this.videosList = response.data.videos;
          this.videosList.forEach(video => this.generateThumbnail(video));
          this.loadItems();
          this.commonDataService.loaderStatus.next(false);

        },
        (error) => {
          if(error.error.errorMessage === null || error.errorMessage === '') {
            this.toastr.error(Something_went_wrong);
          }else {
            this.toastr.error(error.error.errorMessage);
          }
          this.commonDataService.loaderStatus.next(false);
        }
        
      );
    } else if (this.activeTab === 'infographics') {
      this.commonDataService.loaderStatus.next(true);
      this.apiService.getData(Urls.getIapPageInfographics).subscribe(
        (response) => {
          this.infographicsList = response.data.infographics;
          this.loadItems();
          this.commonDataService.loaderStatus.next(false);
        },
        (error) => {
          if(error.error.errorMessage === null || error.errorMessage === '') {
            this.toastr.error(Something_went_wrong);
          }else {
            this.toastr.error(error.error.errorMessage);
          }
          this.commonDataService.loaderStatus.next(false);
        }
      );
    } else if (this.activeTab === 'read') {
      this.commonDataService.loaderStatus.next(true);
      this.apiService.getData(Urls.getIapPageBlogs).subscribe(
        (response) => {
          this.readList = response.data.blogs;
          this.loadItems();
          this.commonDataService.loaderStatus.next(false);
        },
        (error) => {
          if(error.error.errorMessage === null || error.errorMessage === '') {
            this.toastr.error(Something_went_wrong);
          }else {
            this.toastr.error(error.error.errorMessage);
          }
          this.commonDataService.loaderStatus.next(false);
        }
      );
    }
    
  }
  extractVideoId(url: string): string | null {
    const regex = /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=))([^"&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  generateThumbnail(video) {
    const videoId = this.extractVideoId(video.youtubeLink);
    if (videoId) {
      video.thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }
  }

  loadItems() {
    if (this.activeTab === 'watch') {
      this.videos = this.videosList.slice(0, this.displayCount);
    }
    else if (this.activeTab === 'infographics') {
      this.infographics = this.infographicsList.slice(0, this.displayCount);
    }
    else {
      this.reads = this.readList.slice(0, this.displayCount);
    }

  }

  loadMore() {
    this.displayCount += 6; // Increment the count
    this.loadItems(); // Fetch the updated items
  }

  openModal(content: TemplateRef<any>) {
    console.log(content)
    this.modalService.open(content, {
      size: "lg",
      windowClass: "align-modal-center custom-modal-width",
    });

  }
  closePopup(modal: any) {
    modal.close();  // Close the modal
  }

    viewBlogPage(id:any){
      this.router.navigate(['/blogs/view', id]);
    }

    redirectToSocialMedia(shareIcon: number, file: any): void {
      const imageUrl = file; 
      const text = "Check out this!\n";
    
      let url = "";
    
      switch (shareIcon) {
        case 1: // Facebook
          url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            imageUrl
          )}`;
          break;
    
        case 2: // Instagram
          url = "https://www.instagram.com/"; 
          break;
    
        case 3: // Twitter
          url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            text
          )}&url=${encodeURIComponent(imageUrl)}`;
          break;
    
        case 4: // WhatsApp
          url = `https://wa.me/?text=${encodeURIComponent(
            text + " " + imageUrl
          )}`;
          break;
    
        default:
          url = "";
      }
    
      if (url) {
        window.open(url, "_blank");
      }
    }    
  
    public downloadFile(path:string){
      const fileName = path.split("/").pop();
      this.downloadFileService.export(path).subscribe(
        path => saveAs(path,fileName)
      );
     } 
}
